import { createFileRoute } from "@tanstack/react-router";

import type { ChildRouteContext } from "@/root";

import NewsCategories from "@/modules/news/user/components/NewsCategories";

export const Route = createFileRoute("/_panel/_news/news/categories/")({
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("Categories", { ns: "core.shared" }),
        },
      ],
    }) satisfies ChildRouteContext,
  component: RouteComponent,
});

function RouteComponent() {
  return <NewsCategories />;
}
